<template>
    <div id="edit">
        <!-- ERROR MESSAGES LIST -->
        <div class="ui red icon message" v-if="errors.length > 0">
            <i class="warning icon"></i>
            <div class="content">
                <div class="header">
                    <!-- 請處理以下錯誤 -->
                    {{ $t('ui.notifications.error.please_handle_errors') }}
                </div>
                <p v-for="(error, index) in errors">{{index + 1}}. {{error}}</p>
            </div>
        </div>
        <div class="contents" v-if="is_initializing">
            <div class="ui form" :class="{'loading': is_processing}">
                <div class="field">
                    <label>{{ $t('models.attributes.permission_groups.name') }}</label>
                    <input type="text" class="name" v-model="current_data.name">
                </div>

                <div is="PermissionsTable" class="field">
                </div>

                <div class="ui basic positive button" @click="update">
                    {{ $t('ui.general.submit') }}
                </div>
                <router-link :to="{name: 'permission_groups'}" class="ui basic button">
                    <i class="undo icon"></i>
                    {{ $t('ui.general.back') }}
                </router-link>

                <a
                    class="ui basic blue button"
                    style="margin-left: 18px;"
                    v-if="$store.state.back_two_page[0].name != 'permission_groups'"
                    @click.prevent="$router.back()"
                >
                <i class="undo icon"></i>
                    {{ $t("back") }}
                    {{ $t($store.state.back_two_page[0].name) }}
                </a>
            </div>

        </div>
    </div>
</template>

<script>
import PermissionsTable from './permissions_table.vue'

export default {
    name: "EditPermissionGroup",
    data: function () {
        return {
            show_permission_groups: false,
            is_initializing: false,
            is_processing: false,
            is_fetch: false,
            errors: [],
        }
    },
    computed: {
        permission_groups: function() {
            return this.$store.state.provider.permission_groups_module.permission_groups;
        },
        current_data: function() {
            return this.$store.state.provider.permission_groups_module.current_data;
        },
        routes: function() {
            return this.$store.state.provider.routes;
        },
    },
    created: function() {
        
        this.init();
    },
    methods: {
        init: async function() {
            var that = this;

            await that.get_permissions();
            await new Promise(resolve => {
                that.is_processing = false;
                that.is_initializing = true;
                resolve();
            });
        },
        get_permissions: function() {
            var that = this;

            var url = new RestUrl(that.routes.api_v1_provider_permission_group).parse({
                "identity": that.$route.params.identity,
            });

            that.is_processing = true;
            return axios.get(url, {headers: { Authorization: localStorage.getItem("authentication_token") }})
                .then(function (response) {
                    console.log(response.data);
                    if (response.data.status == "success") {
                        that.$store.state.provider.permission_groups_module.current_data = response.data.permission_group;
                    } else {
                        // that.$noty.error('無法取得permission_group');
                        that.$noty.error(
                            that.$t('ui.notifications.error.fetch__name', {
                                name: that.$t('models.permission_groups'),
                            })
                        );
                    }
                })
                .catch(function (error) {
                    // that.$noty.error('取得permission_group失敗');
                    that.$noty.error(
                        that.$t('ui.notifications.error.fetch__name', {
                            name: that.$t('models.permission_groups'),
                            reason: ': ' + error
                        })
                    );
                });
        },
        update: function() {
            var that = this;

            that.errors = [];

            var url = new RestUrl(that.routes.api_v1_provider_permission_group_update).parse({
                "identity": that.$route.params.identity,
            });

            that.is_processing = true;
            axios.post(url, {
                permission_group: that.current_data
            }, {headers: { Authorization: localStorage.getItem("authentication_token") }})
                .then(function (response) {
                    if (response.data.status == "success") {
                        that.$bus.$emit('init');
                        // that.$noty.success('編輯permission_group成功');
                        that.$noty.success(
                            that.$t('ui.notifications.success.update__name', {
                                name: that.$t('models.permission_groups')
                            })
                        );
                    } else {
                        // that.$noty.error('無法更新permission_group');
                        that.$noty.error(
                            that.$t('ui.notifications.error.update__name', {
                                name: that.$t('models.permission_groups')
                            })
                        );
                    }
                    that.is_processing = false;
                })
                .catch(function (error) {
                    // that.$noty.error('更新permission_group失敗');
                    that.$noty.error(
                        that.$t('ui.notifications.error.update__name', {
                            name: that.$t('models.permission_groups')
                        })
                    );
                    that.errors.push(error);
                    that.is_processing = false;
                });

        }
    },
    components: {
        PermissionsTable,
    }
}

function sleep(milliseconds) {
    var start = new Date().getTime();
    for (var i = 0; i < 1e7; i++) {
        if ((new Date().getTime() - start) > milliseconds){
            break;
        }
    }
}
</script>
